<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
      <!--<router-link class="btn btn-primary" to="/ajouter-place">
          <i class="fa fa-plus-circle"></i>
          Ajouter place
        </router-link>--> 
      </div>
      <div class="d-flex align-items-center">
        <form class="search-box position-relative me-15">
          <input type="text" name="mot" v-model="searchTerm"
            class="form-control shadow-none text-black rounded-0 border-0" placeholder="Rechercher une reclamation" />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row d-flex justify-content-center align-items-center text-center">
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Nom
              </th>

              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
               Email
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Objet
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
               Message
              </th>

              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0  pe-0">ACTIONS
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(reclamation, index) in reclamations" :key="index">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ reclamation.nom }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ reclamation.email}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ reclamation?.objet }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ reclamation?.message }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary pe-0">
                <div class="dropdown">
                  <button class="btn btn-sm btn-primary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Actions
                  </button>
                  <ul class="dropdown-menu">
                   <!-- <li>
                      <router-link :to="{ name: 'EditReclamationPage', params: { id: reclamation.id } }"
                        class="dropdown-item d-flex align-items-center"><i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"></i>Modifier</router-link>
                    </li>-->

                    <li class="dropdown-item d-flex align-items-center">
                            <router-link
                              
                              :to="{ name: 'ViewReclamationPage',params: { id: reclamation.id } }"
                            >
                              <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                              Détails
                            </router-link>
                          </li>
                    

                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                        @click="suppression(reclamation.id, reclamations, 'reclamations', `Reclamation ${reclamation.id}`)">
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import Swal from "sweetalert2";
import { Reclamation } from "@/models/Reclamation";
import ApiService from "@/services/ApiService";
import { suppression, error } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import Multiselect from '@vueform/multiselect';
import { Field } from "vee-validate";
export default defineComponent({
  name: "ListeReclamation",
  components: {
    PaginationComponent,
   
  },
  setup() {
    onMounted(() => {
      getAllReclamations();
      });
    const reclamations = ref<Array<Reclamation>>([]);
    const reclamation = ref<Reclamation>();
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllReclamations(page_, limit_);
      } catch (error) {
        //
      }
    };
    function rechercher(){
        getAllReclamations(page.value, limit.value, searchTerm.value );
      }

      watch(searchTerm, async(newValue, oldValue) =>{
        if(newValue != oldValue && newValue != ""){
          await getAllReclamations(1, 10, newValue);
        }
      })
      function getAllReclamations(page = 1, limi = 10, searchTerm = '') {
        return ApiService.get(`/all/reclamations?page=${page}&limit=${limi}&mot=${searchTerm}&`)
          .then(({ data }) => {
            reclamations.value = data.data.data;
            totalPages.value = data.data.totalPages;
            limit.value = data.data.limit;
            totalElements.value = data.data.totalElements;
            return data.data;
          })
          .catch(({ response }) => {
            error(response.data.message)
        });
        
      }
      
    function moddifier(Editreclamations: Reclamation) {
      reclamation.value = Editreclamations;
    }
  
    const deleteReclamation = (id: number) => {
      ApiService.delete(`/reclamations/${id}`)
        .then(({ data }) => {
          Swal.fire({
            text: data.message,
            toast: true,
            icon: 'success',
            title: 'General Title',
            animation: false,
            position: 'top-right',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            heightAuto: false
          });
        })
        .catch(({ response }) => {
          Swal.fire({
            text: response.data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Réssayer à nouveau!",
            heightAuto: false,
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });

      for (let i = 0; i < reclamations.value.length; i++) {
        if (reclamations.value[i].id === id) {
          reclamations.value.splice(i, 1);
        }
      }
    };
    const privileges = ref<Array<string>>(JwtService.getPrivilege());
    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }
    return {
      reclamations,
      checkPermission,
      getAllReclamations,
      deleteReclamation,
      moddifier,
      suppression,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      rechercher,
      searchTerm,
    };
  },
});
</script>